var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "400" } },
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("titles.process-payment")))]),
      _c(
        "w-card-content",
        [
          _c(
            "w-row",
            [
              _vm.favorites.length
                ? _c(
                    "w-col",
                    { attrs: { md: "12" } },
                    [
                      _c("app-select-bank-favorite", {
                        attrs: { fancy: "" },
                        on: {
                          input: function ($event) {
                            return _vm.applyFavorite($event)
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "w-col",
                { attrs: { md: "12" } },
                [
                  _c("w-select", {
                    attrs: {
                      label: _vm.$ct("labels.account"),
                      fancy: "",
                      items: _vm.bankTypeItems,
                    },
                    model: {
                      value: _vm.bank.TypeID,
                      callback: function ($$v) {
                        _vm.$set(_vm.bank, "TypeID", $$v)
                      },
                      expression: "bank.TypeID",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-date-picker", {
                    attrs: {
                      "popover-visibility": "focus",
                      "min-date": _vm.bookYearStartDate,
                      "max-date": _vm.bookYearEndDate,
                      "has-error": !_vm.isDateValid,
                      label: _vm.$ct("labels.TimeCreated"),
                      fancy: "",
                      locale: _vm.locale,
                    },
                    model: {
                      value: _vm.bank.TimeCreated,
                      callback: function ($$v) {
                        _vm.$set(_vm.bank, "TimeCreated", $$v)
                      },
                      expression: "bank.TimeCreated",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { md: "12" } },
                [
                  _c("w-input-number", {
                    attrs: { label: _vm.$ct("labels.amount"), fancy: "" },
                    model: {
                      value: _vm.bank.Total,
                      callback: function ($$v) {
                        _vm.$set(_vm.bank, "Total", $$v)
                      },
                      expression: "bank.Total",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { md: "12" } },
                [
                  _c("w-input", {
                    attrs: { label: _vm.$ct("labels.info"), fancy: "" },
                    model: {
                      value: _vm.bank.Info,
                      callback: function ($$v) {
                        _vm.$set(_vm.bank, "Info", $$v)
                      },
                      expression: "bank.Info",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              attrs: { icon: "ban" },
              on: {
                click: function ($event) {
                  return _vm.cancel()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$t("common.cancel")) + " ")]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              attrs: { disabled: _vm.saving || !_vm.isValid, icon: "save" },
              on: {
                click: function ($event) {
                  return _vm.finish()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$ct("titles.process-payment")) + " ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }